import * as React from 'react';
import { createTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Link } from '@material-ui/core';

const DEFAULT_BRANDING = {
  display_name: 'NoBid',
  copyright_text: 'NoBid, Inc.',
  copyright_url: 'https://nobid.io/',
  primary_color: '#E91E63',
  primary_light: '#EC407A',
  primary_dark: '#880E4F',
  secondary_color: '#CE93D8',
  palette_type: 'dark'
};

export function createTenantTheme (branding) {
  const b = { ...DEFAULT_BRANDING, ...branding };
  const isLight = b.palette_type === 'light';
  const bgDefault = isLight ? '#fafafa' : '#121212';
  const bgPaper = isLight ? '#ffffff' : '#1e1e1e';
  return createTheme({
    palette: {
      type: b.palette_type || 'dark',
      primary: {
        main: b.primary_color,
        light: b.primary_light || b.primary_color,
        dark: b.primary_dark || b.primary_color,
      },
      secondary: {
        main: b.secondary_color || b.primary_color,
        light: '#E1BEE7',
        dark: '#AB47BC',
      },
      background: {
        default: bgDefault,
        paper: bgPaper,
      },
    },
    status: {
      danger: 'orange',
    },
    typography: {
      fontSize: 13,
      h1: { fontWeight: 600 },
      h2: { fontWeight: 600 },
      h3: { fontWeight: 600 },
      h4: { fontWeight: 500 },
      h5: { fontWeight: 500 },
      h6: { fontWeight: 500 },
      body1: { fontWeight: 400 },
      body2: { fontWeight: 400 },
    },
    spacing: 6,
    props: {
      MuiListItem: {
        dense: true,
      },
    },
    overrides: {
      RaList: {
        root: {
          marginTop: '30px'
        }
      },
      MuiCard: {
        root: {
          borderRadius: 8,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
        }
      },
      MuiPaper: {
        root: {
          borderRadius: 8,
        },
        rounded: {
          borderRadius: 8,
        }
      },
      MuiListItem: {
        root: {
          paddingTop: 6,
          paddingBottom: 6,
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
          },
          '&.Mui-selected': {
            backgroundColor: `${b.primary_color}29`,
            borderLeft: `3px solid ${b.primary_color}`,
            '&:hover': {
              backgroundColor: `${b.primary_color}3D`,
            },
          },
        },
        button: {
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
          },
        },
      },
      MuiButton: {
        root: {
          borderRadius: 6,
          padding: '6px 16px',
          textTransform: 'none',
        },
        containedPrimary: {
          backgroundColor: b.primary_color,
          '&:hover': {
            backgroundColor: b.primary_dark || b.primary_color,
          },
        },
      },
      MuiIconButton: {
        root: {
          padding: 8,
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
          },
        },
      },
    }
  });
}

// Default theme (backwards compatible)
export const theme = createTenantTheme(DEFAULT_BRANDING);

export const useFormStyles = makeStyles(() => ({
  paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
  },
  avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
  },
  form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
  },
  submit: {
      margin: theme.spacing(3, 0, 2),
  }
}));

export function Copyright({ branding }) {
  const b = { ...DEFAULT_BRANDING, ...branding };
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href={b.copyright_url}>
        {b.copyright_text}
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export { DEFAULT_BRANDING };
